export class DataCache
{
    static USER_DATA: string = "USER_DATA";
    static USER_DATA_KEY: string = "*sixdeempt@IVRUSER_DATA";
    static CONFIGURATION_SETTINGS: string = "CONFIGURATION_DATA";
    static CONFIGURATION_SETTINGS_KEY: string = "*sixdeempt@IVRCONFIGURATION_SETTINGS";
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/usercontext/datacacheenum.ts